import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

// TODO: triggered from drupal brand-specific analytics.js
const defaultData: IDataLayer = {
  event_name: 'Product Thumbnail Clicks',
  event_category: 'Product Thumbnail Clicks',
  event_action: null, // '<alt image > - <image name> - <swipe/drag/click>'
  event_label: null, // '<product name> - <product id>'
};

function trackProductThumbnailClick(_: string, eventData: IDataLayer = {}) {
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler(
  'productThumbnailClick',
  trackProductThumbnailClick,
);
